import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ChangePassword from "@/pages/ChangePassword";
import Inventory from "@/pages/Inventory";
import UnitDetail from "@/pages/UnitDetail";
import AddMac from "@/pages/AddMac";
import Enquiries from "@/pages/Enquiries";
import EnquiryDetail from "@/pages/EnquiryDetail";
import Dashboard from "@/pages/Dashboard";
import Settings from "@/pages/Settings";
import OwnerSettings from "@/pages/OwnerSettings";

function Protected({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === undefined)
    return (
      <div className="flex min-h-screen items-center justify-center bg-black">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-white/20 border-t-[#2997ff]" />
      </div>
    );
  if (user === null) return <Navigate to="/login" state={{ from: location }} replace />;
  if (user.must_change_password) return <ChangePassword />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Protected><Inventory /></Protected>} />
      <Route path="/unit/:id" element={<Protected><UnitDetail /></Protected>} />
      <Route path="/add" element={<Protected><AddMac /></Protected>} />
      <Route path="/enquiries" element={<Protected><Enquiries /></Protected>} />
      <Route path="/enquiries/:id" element={<Protected><EnquiryDetail /></Protected>} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/settings" element={<Protected><Settings /></Protected>} />
      <Route path="/settings/owner" element={<Protected><OwnerSettings /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster theme="dark" position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
